import React from 'react';

import SvgContainer from '../SvgContainer';

const Spa = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9078_100940)">
                <path d="M10.792 6.104C10.648 3.872 9.744 1.696 8.048 0C6.336 1.712 5.392 3.888 5.208 6.104C6.232 6.648 7.176 7.352 8 8.208C8.824 7.36 9.768 6.656 10.792 6.104ZM5.592 8.224C5.48 8.144 5.352 8.072 5.232 7.992C5.352 8.08 5.48 8.144 5.592 8.224ZM10.728 8.024C10.624 8.096 10.512 8.152 10.408 8.232C10.512 8.152 10.624 8.096 10.728 8.024ZM8 10.76C6.28 8.136 3.344 6.4 0 6.4C0 10.656 2.688 14.256 6.424 15.592C6.928 15.776 7.456 15.912 8 16C8.544 15.904 9.064 15.768 9.576 15.592C13.312 14.256 16 10.656 16 6.4C12.656 6.4 9.72 8.136 8 10.76Z" />
            </g>
            <defs>
                <clipPath id="clip0_9078_100940">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Spa;
